<div class="flex flex-col gap-8 text-[var(--color-text-strong)]">
    <div class="pt-2">
        <p class="text-base mb-4" [innerHTML]="config.data?.message ?? '' | translate"></p>
    </div>

    <div class="flex justify-end items-center gap-2 mt-8">
        <sh-button
            color="secondary"
            icon="arrow-line-left-s"
            iconPosition="left"
            layout="compact"
            ariaLabel="Close button"
            (clicked)="onClose()"
            [label]="'seasons.season-details.dialogs.close-season-dialog.cancel' | translate"
        />
        <sh-button
            icon="arrow-line-right-s"
            iconPosition="left"
            layout="compact"
            ariaLabel="Confirm button"
            (clicked)="onClose('confirm')"
            [label]="'seasons.season-details.dialogs.close-season-dialog.confirm' | translate"
        />
    </div>
</div>
